import {loadCSS, loadJS} from './util';

export function loadEcharts() {
  return loadJS('echarts', 'https://s.phemex.com/100/3rd/echarts/5.4.3/echarts.min.js');
}

export function loadGoogleRecaptcha(siteKey: string) {
  return loadJS('google-recaptcha', `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}&r=${Date.now()}`);
}

export function loadHtml2Canvas() {
  return loadJS('html2canvas', 'https://s.phemex.com/100/3rd/html2canvas/1.4.1/html2canvas.min.js');
}

export function loadJsEncrypt() {
  return loadJS('js-encrypt', 'https://s.phemex.com/100/3rd/jsencrypt/3.3.1/jsencrypt.min.js');
}

export function loadSendBird() {
  return Promise.all([loadJS('axios', 'https://s.phemex.com/100/3rd/axios/1.3.4/axios.min.js'), loadJS('send-bird', 'https://s.phemex.com/100/3rd/sendbird/3.1.17/sendbird.min.js')]);
}

export function loadXLSX() {
  return loadJS('xlsx', 'https://s.phemex.com/100/3rd/xlsx/0.16.1/xlsx.full.min.js');
}

export function loadTvScript() {
  return loadJS('charting-library', 'https://static.phemex.com/s/tv/24.002/charting_library.js');
}

export function loadGoogleAccountScript() {
  return loadJS('google', 'https://accounts.google.com/gsi/client');
}

export function loadWeb3() {
  return loadJS('web3', 'https://s.phemex.com/100/3rd/web3/1.9.0/web3.min.js');
}

export function loadCryptoJS() {
  return loadJS('crypto-js', 'https://s.phemex.com/100/3rd/crypto-js/4.1.1/crypto-js.min.js');
}

export function loadCropperJS() {
  return loadJS('cropper-js', 'https://static.phemex.com/s/3rd/cropper/cropper-1.6.1.min.js');
}

export function loadCropperCSS() {
  return loadCSS('cropper-css', 'https://static.phemex.com/s/3rd/cropper/cropper-1.6.1.min.css');
}
export function loadTelegramWidget() {
  return loadJS('telegram-widget', 'https://telegram.org/js/telegram-widget.js?10');
}

export function loadAppleWidget() {
  return loadJS('apple-widget', 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js');
}

export function loadColorThiefJS() {
  return loadJS('color-thief', 'https://cdnjs.cloudflare.com/ajax/libs/color-thief/2.3.2/color-thief.umd.js');
}
